import { POURCENTAGE } from '@/configuration/devisConf';
import { ANNEE } from '@/configuration/baux/contrat/contratConf';
import formatDate from '@/services/general/formatIsoDate';
import moment from 'moment';
import { cloneDeep } from 'lodash';
import calculArrondi from '@/services/calcul/calculArrondi';
import { formatPourcentageToNumber, isNoPropertie } from './services';

function handleDate(date) {
  return moment(date, 'DD/MM/YYYY').toDate();
}

export function genererEcheancierDto(dateDebut, dateFin, intervenants) {
  return {
    echeancier: {
      dateDebut: formatDate(dateDebut),
      dateFin: formatDate(dateFin),
      dateFinPremierePremièreEcheance: null,
      quantitePeriodicite: 1,
      unitePeriodicite: ANNEE,
      referenceEcheancier: null,
    },
    montant: 0,
    tiers: intervenants.map(i => {
      return {
        tiersId: i.tiersId,
        repartition: formatPourcentageToNumber(i.repartition),
        typeRepartition: POURCENTAGE,
      };
    }),
  };
}

function addEcheanceDto(ligne, premiereEchDto, echsDto) {
  const echeancierToCreate = [];
  if (parseFloat(ligne.montantPremiereEcheance) === 0) return echeancierToCreate;
  if (ligne.referenceEcheancier) {
    const premiereEch = cloneDeep(premiereEchDto);
    premiereEch.echeancier.referenceEcheancier = ligne.referenceEcheancier;
    premiereEch.montant = calculArrondi(parseFloat(ligne.montantPremiereEcheance));
    echeancierToCreate.push(premiereEch);
    const allEch = cloneDeep(echsDto);
    allEch.echeancier.referenceEcheancier = ligne.referenceEcheancier;
    allEch.montant = calculArrondi(parseFloat(ligne.totalHtAvecLigneRemise) - premiereEch.montant);
    if (allEch.montant !== 0) echeancierToCreate.push(allEch);
  }
  return echeancierToCreate;
}

export function genererEcheancierCommandeDtos(commande, fileCommande) {
  const echeancierToCreate = [];
  const intervenants = commande.intervenants
    .filter(i => formatPourcentageToNumber(i.repartition) !== 0);

  const premiereEchDto = genererEcheancierDto(
    handleDate(fileCommande.echeancierDateDebut),
    handleDate(fileCommande.echeancierDateFinPremiereEcheance),
    intervenants,
  );

  const echsDto = genererEcheancierDto(
    moment(fileCommande.echeancierDateFinPremiereEcheance, 'DD/MM/YYYY').add(1, 'days').toDate(),
    handleDate(fileCommande.echeancierDateFin),
    intervenants,
  );

  for (let i = 0; i < commande.lignesCommande.length; i += 1) {
    const ligneRegroupement = commande.lignesCommande[i];
    if (!isNoPropertie(ligneRegroupement.lignesCommande)) {
      ligneRegroupement.lignesCommande.forEach(ligneNormal => {
        echeancierToCreate.push(addEcheanceDto(ligneNormal, premiereEchDto, echsDto));
      });
    } else {
      echeancierToCreate.push(addEcheanceDto(ligneRegroupement, premiereEchDto, echsDto));
    }
  }

  return echeancierToCreate.flat(3);
}
